import {
  Dialog as MuiDialog,
  DialogActions,
  DialogContent,
  Stack,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledDialog = styled(MuiDialog)(() => ({
  '& .MuiDialog-paper': {
    borderRadius: 20,
    minWidth: '400px',
    maxWidth: '100%',
    boxShadow: '0px 8px 19.3px -6px rgba(0,0,0,0.09)',
    overflow: 'hidden',
  },
  '& .MuiBackdrop-root': {
    backdropFilter: 'blur(5px)',
    WebkitBackdropFilter: 'blur(5px)',
    backgroundColor: '#FFFFFF33',
  },
}));

export const StyledDialogTitle = styled(Typography)(({ theme }) => ({
  fontSize: 'inherit',
  fontWeight: 'inherit',
  lineHeight: 'inherit',
}));

export const StyledDialogTitleContainer = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.secondary.contrastText,
  padding: '22px',
  fontSize: 20,
  fontWeight: 500,
  lineHeight: '100%',
}));

export const StyledDialogContent = styled(DialogContent, {
  shouldForwardProp: (prop) => prop !== 'noContentPadding',
})<{
  noContentPadding: boolean;
}>(({ noContentPadding }) => ({
  ...(noContentPadding && {
    padding: '0 !important',
  }),

  ...(!noContentPadding && {
    paddingTop: '25px !important', // Исправляет автоматическое правило MUI, которое убирает padding-top у DialogContent когда он следует за DialogTitle
    paddingBottom: '25px',
    paddingRight: '22px',
    paddingLeft: '22px',
  }),
}));

export const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'left',
  padding: '0 22px 32px',
}));
